export default [
  // errors routes =====================================================
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    meta: { title: "error 404" },
    component: () => import("../../views/errors/404.vue"),
  },
  {
    path: "/page-error-500",
    name: "error500",
    meta: { title: "error 500" },
    component: () => import("../../views/errors/500.vue"),
  },

  {
    path: "/",
    name: "Home",
    meta: { title: "Landing Home" },
    component: () => import("../../views/guest/kabayani.vue"),
  },

  {
    path: "/nyvp/about",
    name: "About NYVP",
    meta: { title: "About NYVP" },
    component: () => import("../../views/guest/about-nyvp.vue"),
  },

  {
    path: "/yorp/about",
    name: "About Yorp",
    meta: { title: "About Yorp" },
    component: () => import("../../views/guest/yorp/about-yorp.vue"),
  },
  {
    path: "/yorp/register-organization",
    name: "Register Organization",
    meta: { title: "Register Organization" },
    component: () => import("../../views/guest/yorp/register-org.vue"),
  },
  {
    path: "/yorp/request-lydo-account",
    name: "Request LYDO Account",
    meta: { title: "Request LYDO Account" },
    component: () => import("../../views/guest/yorp/request-lydo.vue"),
  },
  {
    path: "/yorp/organization-list",
    name: "Organization List",
    meta: { title: "Organization List" },
    component: () => import("../../views/guest/yorp/organization-list.vue"),
  },

  {
    path: "/resources/templates",
    name: "Resources Templates",
    meta: { title: "Resources Templates" },
    component: () => import("../../views/guest/resources/templates.vue"),
  },
  {
    path: "/resources/faqs",
    name: "Resources FAQs",
    meta: { title: "Resources FAQs" },
    component: () => import("../../views/guest/resources/faqs.vue"),
  },
  {
    path: "/resources/pydp",
    name: "Resources PYDP",
    meta: { title: "Resources PYDP" },
    component: () => import("../../views/guest/resources/pydp.vue"),
  },


  {
    path: "/login",
    name: "Login",
    meta: { title: "Login | Account" },
    component: () => import("../../views/guest/auth/login.vue"),
  },
   {
    path: "/forgot-password",
    name: "ForgotPassword",
    meta: { title: "Forgot Password" },
    component: () => import("../../views/guest/auth/forgot-password.vue"),
  },
   {
    path: "/reset-password",
    name: "ResetPassword",
    meta: { title: "Reset Password" },
    component: () => import("../../views/guest/auth/reset-password.vue"),
  },
];
